import clsx from 'clsx'
import PropTypes from 'prop-types'

/**
 * Formen der Version „Aivy Play“: das Signet in vier Teilen und das flache
 * Formenvokabular (Kreis, Quadrat, Dreieck, Halbkreis, Viertelkreis).
 */

export const C = {
  blue: '#407BFF',
  markBlue: '#4264DC',
  green: '#43DBBD',
  teal: '#00CEC8',
  yellow: '#FFB628',
  pink: '#FE79A7',
  ink: '#182033'
}

// Geometrie aus aivyicon.svg (64 × 56), Reihenfolge wie im Original
export const MARK = [
  {
    id: 'pink',
    color: C.pink,
    t: [0, 0],
    d: 'M62.9024197,52.5405494 L33.2020455,1.59066988 C32.8307738,0.954428916 32.1747469,0.650814458 31.5255323,0.669031325 L31.5241699,0.669031325 C31.2189777,0.677127711 30.9165105,0.755392771 30.6453799,0.909224096 C30.6085934,0.92946506 30.5786192,0.961175904 30.5431951,0.984115663 C30.4471413,1.04753735 30.3504063,1.10893494 30.2659334,1.19259759 C30.1487615,1.30594699 30.0438517,1.43818795 29.9552914,1.59066988 L0.254235966,52.5405494 C0.0737093557,52.8495614 -0.00531361345,53.1788145 -0.000126887496,53.497947 C0.0171670588,54.4492723 0.786278543,55.3115373 1.85785725,55.3230072 C1.86466958,55.3230072 1.87011944,55.3250313 1.87693176,55.3250313 L1.87693176,55.3250313 L22.1708477,55.3250313 L31.5255323,39.2786699 L40.8795357,55.3250313 L61.2790427,55.3250313 C62.7218931,55.3250313 63.6238449,53.777947 62.9024197,52.5405494'
  },
  {
    id: 'yellow',
    color: '#FFB629',
    t: [0, 33.73],
    d: 'M31.8765714,0.556086747 C19.2574207,0.556086747 8.13153165,6.9104 1.55286947,16.5774843 L0.702691317,18.0368578 L0.253759104,18.8053398 C-0.106612885,19.4247133 -0.0616515406,20.1210024 0.253759104,20.6621108 C0.275558543,20.6985446 0.307576471,20.7275566 0.330738375,20.762641 C0.395455462,20.8577735 0.458810084,20.9535807 0.539195518,21.035894 C0.582794398,21.0790747 0.63797423,21.1107855 0.685660504,21.1505928 C0.759914846,21.2119904 0.82940056,21.2787855 0.913192157,21.329388 C0.975865546,21.3664964 1.05011989,21.3867373 1.1175619,21.4164241 C1.1993098,21.4521831 1.27560784,21.4967133 1.36348683,21.5210024 C1.43842241,21.5419181 1.52221401,21.5419181 1.60123697,21.553388 C1.69320336,21.5668819 1.78040112,21.5904964 1.87713613,21.5904964 L22.1710521,21.5904964 L34.3787384,0.649195181 C33.5510409,0.59386988 32.7185748,0.556086747 31.8765714,0.556086747'
  },
  {
    id: 'blue',
    color: C.markBlue,
    t: [19.76, 0],
    d: 'M21.1239978,55.3253012 L41.5235048,55.3253012 C42.9609053,55.3253012 43.8587697,53.7910361 43.1530129,52.5556627 L13.4356078,1.57744578 C12.7080515,0.354216867 10.9177725,0.357590361 10.1990723,1.59026506 L-0.000340616246,19.0872289 L21.1239978,55.3253012 Z'
  },
  {
    id: 'teal',
    color: C.teal,
    t: [0, 0],
    d: 'M28.6954201,34.4234699 L40.8799444,55.3249639 L61.2794514,55.3249639 C62.7161708,55.3249639 63.6147164,53.7906988 62.9089596,52.556 L59.7977708,47.2184578 C53.0556128,39.3150361 42.9801842,34.2912289 31.7160049,34.2912289 C30.6975624,34.2912289 29.6927444,34.3431807 28.6954201,34.4234699'
  }
]

/** Das Signet als SVG, jedes Teil liegt in einer eigenen Gruppe. */
export function Mark({ className, pieceStyle }) {
  return (
    <svg
      viewBox='0 0 64 56'
      className={clsx('ap-mark', className)}
      aria-hidden='true'
    >
      {MARK.map((p, i) => (
        <g key={p.id} className='ap-mark__piece' style={pieceStyle?.(p, i)}>
          <path
            d={p.d}
            fill={p.color}
            transform={`translate(${p.t[0]} ${p.t[1]})`}
          />
        </g>
      ))}
    </svg>
  )
}

Mark.propTypes = { className: PropTypes.string, pieceStyle: PropTypes.func }

const TRI =
  'M12 2.2c.55 0 1.05.3 1.33.77l9.5 16.46c.6 1.03-.15 2.32-1.33 2.32H2.5c-1.18 0-1.93-1.29-1.33-2.32l9.5-16.46c.28-.48.78-.77 1.33-.77Z'

/** Eine flache Aivy-Form in einem 24er-Raster. */
export function Shape({ kind, color, size = 24, className, style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      className={className}
      style={style}
      aria-hidden='true'
    >
      {kind === 'circle' && <circle cx='12' cy='12' r='11' fill={color} />}
      {kind === 'square' && (
        <rect x='1.5' y='1.5' width='21' height='21' rx='4.5' fill={color} />
      )}
      {kind === 'tri' && <path d={TRI} fill={color} />}
      {kind === 'half' && <path d='M1 17a11 11 0 0 1 22 0Z' fill={color} />}
      {kind === 'quarter' && (
        <path d='M3 21V3a18 18 0 0 1 18 18Z' fill={color} />
      )}
      {kind === 'ring' && (
        <rect
          x='3'
          y='3'
          width='18'
          height='18'
          rx='4'
          fill='none'
          stroke={color}
          strokeWidth='3'
        />
      )}
    </svg>
  )
}

Shape.propTypes = {
  kind: PropTypes.oneOf(['circle', 'square', 'tri', 'half', 'quarter', 'ring'])
    .isRequired,
  color: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object
}

/*
 * Umrisse für den Morph Dreieck → Quadrat → Kreis. Alle drei werden über
 * dieselben Winkel abgetastet, so lassen sich die Radien direkt mischen.
 * Ecken werden über ein verallgemeinertes Mittel der Kantenabstände rund.
 */
const N = 96
const ANG = Array.from(
  { length: N },
  (_, k) => -Math.PI / 2 + (k * 2 * Math.PI) / N
)

function outline(edges, q) {
  return ANG.map((a) => {
    let sum = 0
    edges.forEach(([phi, h]) => {
      const c = Math.cos(a - phi)
      if (c > 1e-4) sum += Math.pow(c / h, q)
    })
    return Math.pow(sum, -1 / q)
  })
}

const deg = (d) => (d * Math.PI) / 180
// Dreieck mit Spitze oben, auf seine Box zentriert
const TRI_D = 0.54
const TRI_C = TRI_D / 2
export const OUTLINES = {
  tri: outline(
    [
      [deg(90), TRI_D + TRI_C],
      [deg(210), TRI_D - 0.5 * TRI_C],
      [deg(330), TRI_D - 0.5 * TRI_C]
    ],
    11
  ),
  square: outline(
    [
      [0, 0.9],
      [deg(90), 0.9],
      [deg(180), 0.9],
      [deg(270), 0.9]
    ],
    16
  ),
  circle: ANG.map(() => 0.96)
}

/** clip-path-Polygon aus gemischten Radien, `rot` dreht den Umriss. */
export function morphPolygon(a, b, t, rot = 0) {
  const pts = ANG.map((ang, k) => {
    const r = a[k] + (b[k] - a[k]) * t
    const x = 50 + Math.cos(ang + rot) * r * 50
    const y = 50 + Math.sin(ang + rot) * r * 50
    return `${x.toFixed(2)}% ${y.toFixed(2)}%`
  })
  return `polygon(${pts.join(',')})`
}
